import privacyPolicy from './data/privacy-policy-hk'
import provisionStatement from './data/provision-statement-hk'
import provisionStatementCn from './data/provision-statement-cn-hk'
import analystRule from './data/analyst-rule-hk'
import cancelAccount from './data/cancel-account-hk'
import quoteService from './data/quote-service-hk'
import thirdPartyShare from './data/third-party-share-hk'
import thirdPartyShareCn from './data/third-party-share-cn-hk'
import biometricAuthentication from './data/biometric-authentication-hk'
import communityRule from './data/community-rule-hk'
import communityRuleCn from './data/community-rule-cn-hk'
import communityPrivilegeRule from './data/community-privilege-rule-hk'
import communityIncomeRule from './data/community-income-rule-hk'
import eventTerms from './data/event-terms-hk'
import ipoSubscriptionStatement from './data/ipo-subscription-statement-hk'
import conditionOrderDisclaimer from './data/condition-order-disclaimer-hk'

import thirdPartyShareGoogle from './data/third-party-share-google-hk'

import provisionStatementGoogle from './data/provision-statement-google-hk'

import financingPowerExplain from './data/financing-power-explain-hk'

export default {
  // 通用翻译
  common: {
    confirm: '確定',
    return: '返回',
    cancel: '取消',
    noData: '暫無數據',
    noInfo: '暫無相關信息',
    reminder: '溫馨提示',
    pleaseGoAppHandle: '請前往app操作',
    reqError: '請求失敗，請稍後重試',
    handleError: '操作失敗，請重試',
    paramError:"參數錯誤",
    open:"打開",
    openAccountTip:"開戶提示",
    gotoOpenAccount:"您尚未完成開戶，是否前去開戶？",
    updateAppTips:"當前App版本暫不支持一鍵跳轉，請升級至最新版本體驗",
    info:"資訊"
  },

  router: {
    winbull: '盈寶證券',
    helpCenter: '幫助中心',
    privacyPolicy: '隱私政策',
    provisionStatement: '服務協議',
    analystRule: '分析師規則',
    cancelAccount: '註銷賬號',
    quoteService: '盈寶行情服務協議',
    thirdPartyShare: '第三方分享資訊情況說明',
    biometricAuthentication: '生物認證服務條款',
    communityRule: '社區規則',
    communityPrivilegeRule: '社區權益規則',
    communityIncomeRule: '獎勵規則',
    eventTerms: '活動條款',
    ipoSubscriptionStatement: '盈寶證券(香港)新股認購聲明',
    conditionOrderDisclaimer: '條件單風險聲明',
    tradeTerm: '說明',
    financingPowerExplain: '融資購買力說明',
    aiAnalysis: '盈寶AI股票分析',
    feedBackQuestion:"問題反饋",
    newDetail:"資訊詳情",
    kline: 'K線形態',
    shareOption: '期權動態解讀',
    magicNineTurns:"神奇九轉",
    winbullAiInfo:"盈寶AI資訊",
    activityInfo:"活動詳情",
    fastInfo:"快訊",
    winbullActivity:"盈寶活動",
  },

  helpIndex: {
    type0: '證券問題',
    type1: '社區問題'
  },

  search: {
    searchBarInputHolder: '請輸入您想了解的資訊',
    fapTitle: '常見問題',
    searching: '搜索中',
    noSearch: '未搜索到與',
    hasSearch: '搜索到與',
    relatedInformation: '相關內容',
    totol: '共',
    strip: '條',
    loadMore: '加載更多'
  },

  aiAnalysis: {
    analyzing: '分析中…',
    analyzingResult: '分析答案中…',
    dataLoading: '數據加載中...',
    analyResult: '分析答案',
    finishAnalyResult: '分析答案完成',
    refreshAnalysis: '重新分析',
    aiTip: '提示：AI分析“基於Deepseek- R1”的深度推理，內容均為AI生成，僅供分析慘考，不構成直接投資建議。',
    aiTip2: '提示：當前內容由AI基於交易日',
    aiTip3: '行情資訊數據進行分析，內容均為AI生成，僅供分析參考，不構成直接投資建議',
    pressureLevel: '壓力位',
    supportLevel: '支撐位',
    recommendedLevel: '推薦等級',
    bullish: '看多',
    strongBullish: '強烈看多',
    bullish2: '看漲',
    neutral: '中性',
    neutral2: '中性',
    bearish: '看空',
    strongBearish: '強烈看空',
    bearish2: '看跌',
    help_less:"沒有幫助",
    data_error:"數據錯誤",
    other:"其他反饋",
    submit:"提交",
    type:"類型",
    enter_feed_back:"您的反饋，驅動我們成長",
    thanksYourFeedBack:"感謝您的反饋，我們將持續優化產品體驗",
    useful:"有用",
    feedBack:"反饋",
    share:"分享",
    relateInfo:"相關AI資訊",
    shareTitle:"AI股票分析",
    shareDesc:"ai分析內容",
    newTip:"資訊由AI檢索生成，請謹慎甄別，不作為投資建議。",
    outNewTip:"即將跳轉外部鏈接，請謹慎甄別信息",
    viewOrigin:"查看引用來源",
    auoteInfo:"資訊由AI根據市場熱點和股票檢索獲取，並由AI進行整理和情緒判斷，僅供參考，不構成投資建議。",
    urlIsNull:"當前鏈接不不存在，請稍後再試...",
    connectInfo:"引用資訊",
    recommendRead:"推薦閱讀",
    emptyInfo:"暫無相關資訊",
    fastAuoteInfo:"快訊信息由AI基於公開市場信息檢測、分析、整理生成，僅供參考，不構成投資建議。",
    closePrice:"收盤價",
    analysisTip:"提示：當前內容由AI基於當天行情資訊數據進行分析，內容均為AI生成，僅供分析參考，不構成直接投資建議"
  },

  doc: {
    privacyPolicy: privacyPolicy,
    provisionStatement: provisionStatement,
    provisionStatementCn: provisionStatementCn,
    analystRule: analystRule,
    cancelAccount: cancelAccount,
    quoteService: quoteService,
    thirdPartyShare: thirdPartyShare,
    thirdPartyShareCn: thirdPartyShareCn,
    biometricAuthentication: biometricAuthentication,
    communityRule: communityRule,
    communityRuleCn: communityRuleCn,
    communityPrivilegeRule: { ...communityPrivilegeRule },
    communityIncomeRule: communityIncomeRule,
    eventTerms: eventTerms,
    ipoSubscriptionStatement: ipoSubscriptionStatement,
    conditionOrderDisclaimer: conditionOrderDisclaimer,
    thirdPartyShareGoogle: thirdPartyShareGoogle,
    provisionStatementGoogle: provisionStatementGoogle
  },

  financingPowerExplain: financingPowerExplain,

usOption:{
   contractInfo:"合約要素",
   contractAttibute:"合約屬性",
   contractAttibute1_title:"行權價",
   contractAttibute1:"期權中對標的資產買入或賣出的約定價格，期權價值高度依賴於當前標的價格與行權價的關系。",
   contractAttibute2_title:"到期日",
   contractAttibute2:"期權合約有效的最後日期，到期後合約失效。期權分為歐式（只能在到期日行權）和美式（可在到期日前任何時間行權）。",
   contractAttibute3_title:"合約規模",
   contractAttibute3:"每張期權代表多少單位的標的資產，美股標準1張期權=100股標的股票，例如買入一張特斯拉的Call，即代表擁有未來以特定價格買入100股特斯拉股票的權利。（當標的股票發生公司行動時，合約規模可能會發生相應調整）。",
   contractAttibute4_title:"合約乘數",
   contractAttibute4:"每張期權合約對應標的資產價值的乘數，比如乘數為 100，行權價為 200美元，代表該合約對應價值為 100*200 = 20000美元。",
   contractAttibute5_title:"內在價值",
   contractAttibute5:"期權標的價格與行權價之間的有利差額，代表期權在當前時間立即行權所能產生的潛在收益。",
   contractAttibute51:"看漲期權 (Call)：內在價值 = max (標的價格 – 行權價, 0)。",
   contractAttibute52:"看跌期權 (Put)：內在價值 = max (行權價 – 標的價格, 0)。",
   contractAttibute6_title:"時間價值",
   contractAttibute6:"期權價格中超出內在價值的部分，反映期權在到期前有變得獲利的時間潛力，時間價值會隨著期權到期日的逐近而衰減，最終在到期日變為零。",
   contractAttibute61:"時間價值 = 期權的市場價格 - 內在價值。",
   
   optionIndex:"期權指標",
   optionIndex1_title:"隱含波動率",
   optionIndex1:"市場對標的資產未來波動性的預期，隱含波動率越高，意味著市場預期未來價格波動越大，期權價格越高。",
   optionIndex2_title:"溢價",
   optionIndex2:"衡量當前期權價格相對於其內在價值的超額溢價程度，反應市場對未來波動和時間價值的溢價支付意願。",
   optionIndex3_title:"杠桿倍數",
   optionIndex3:"表示當采用期權來控制同等數量標的資產所需的資金，期權權利金相比於購買標的資產本身所需資金的比率，代表資金的杠桿效應。",
   optionIndex31:"杠桿倍數 = 資產標的價格 / 期權價格。",
   optionIndex4_title:"有效杠桿",
   optionIndex4:"衡量期權價格百分比變動相對於標的資產價格百分比變動的倍數，直接反映了期權收益率相對於標的資產收益率的放大倍數。",
   optionIndex41:"有效杠桿 = Delta*杠桿倍數。",

   greekAlphabet:"希臘字母",
   greekAlphabet1_title:"Delta",
   greekAlphabet1:"代表期權價格對標的資產價格變化的敏感性，對於Call期權，假設Delta=0.6，表示標的股票上漲$1，理論上期權價格將上漲$0.6。",
   greekAlphabet2_title:"Gamma",
   greekAlphabet2:"表示Delta對標的資產價格變化的敏感度，即標的價格每波動1美元，Delta的變化量。Gamma值越大，Delta變化越快，期權對標的價格波動越敏感。",
   greekAlphabet3_title:"Vega",
   greekAlphabet3:"代表期權價格對標的資產波動率變化的敏感性，假設Vega=0.25，表示標的資產波動率上漲1%時，期權價格上漲$0.25。",
   greekAlphabet4_title:"Theta",
   greekAlphabet4:"代表期權價格隨時間衰減的變化率（時間價值損耗），Theta值一般為負數，表明隨著時間推移，期權價值將減少。",
   greekAlphabet5_title:"Rho",
   greekAlphabet5:"代表期權價格對無風險利率變化的敏感性，若Rho=0.4，表示利率上漲1%時，期權價格上漲$0.4。",

   priceCaculator:"期權價格計算器",
   caculatorDesc1:"期權價格計算器是一款簡單實用的金融工具，幫助您在交易決策中，計算期權的理論價格。影響期權金的主要因素有：",
   caculatorDesc2:"正股價格、剩余到期時間、隱含波動率，",
   caculatorDesc3:"通過修改任一參數，可以計算出期權新的理論價格。",
   caculatorDesc4:"期權價格計算器采用的是Black-Scholes 期權定價模型和針對美式期權的二叉樹模型計算得出。Black-Scholes 期權定價模型是金融史上最具影響力的模型之一，由經濟學家 Fischer Black 和 Myron Scholes 於1973 年提出，並因此榮獲 1997 年諾貝爾經濟學獎。該模型提出的 BSM（Black-Scholes-Merton）公式，被譽為20 世紀最偉大的金融公式，也是“全球最美十大公式”之一。",
   caculatorDesc5:"示例1",
   caculatorDesc51:"買入期權時，判斷期權當前價格是否合理",
   caculatorDesc52:"當前某期權的市場報價為$3.20，但計算器顯示其理論價格為$2.70，說明市場可能存在過熱，需謹慎入場。",
   caculatorDesc6:"示例2：",
   caculatorDesc61:"通過判斷正股價格漲跌買賣期權",
   caculatorDesc62:"當前某股票正股價格為$3.0，您持有該股票的Call期權，並預期今天該股票最高可以漲至$3.5。您可以在期權計算器修改正股價格為$3.5，得出持有期權的理論價格，並以該理論價格為參考掛單將期權平倉賣出。",
   caculatorDesc7:"示例3",
   caculatorDesc71:"評估期權的時間損耗",
   caculatorDesc72:"您持有一個Call期權，想要知道在未來5天，如果正股價格持續震蕩（幾乎無漲跌）的場景下，期權的時間損耗。您可以在期權計算器修改到期日，得出5天後期權的理論價格。",
   caculatorDesc8:"免責聲明：盈寶證券致力於確保期權計算器依據模型所得結果準確性，無法保證結果絕對無誤。所有計算結果僅供參考之用，不構成任何投資建議。",
   whatIsOptionCaculator:"什麽是期權計算器？",
   optionCaculatorDemo:"期權計算器示例場景"
  },
  kline: {
    mainTitle1: 'K線形態由多根K線的開盤價、收盤價、最高價和最低價共同構成，是價格運行的直觀結構表達。它反映了市場多空力量的轉換與博弈，可輔助識別趨勢方向與潛在的反轉或延續信號。',
    mainTitle2: '由於K線形態本身並非確定性工具，實際中應結合趨勢結構、成交量變化、技術指標及基本面因素進行綜合研判，以提高分析的可靠性與交易決策的品質。',
    titleTips: '盈寶證券致力於提供股票K線形態信號識別的準確性，無法保證結果絕對無誤。該信號結果僅供參考之用，不構成任何投資建議',
    title1: '棄嬰看漲',
    title2: '棄嬰看跌',
    title3: '刺穿線',
    title4: '烏雲蓋頂',
    title5: '錘子線',
    title6: '上吊線',
    title7: '啟明星',
    title8: '黃昏之星',
    title9: '三個白武士',
    title10: '三隻烏鴉',
    title11: '多方炮',
    title12: '空方炮',
    title13: '看漲吞沒',
    title14: '看跌吞沒',
    title15: '上升三法',
    title16: '下降三法',
    title17: '平頭底',
    title18: '平頭頂',
    desc1: '底部反轉信號。第一根為下跌長陰，第二天跳空低開形成十字星，與前後K線無重疊，第三天大陽線高開高走並收回前陰部分。顯示空方能量耗盡，多方接管，常出現在明顯下跌末期，是較強的見底信號。',
    desc2: '頂部反轉信號。第一根上漲長陽，第二天跳空高開形成十字星，與兩側K線脫離，第三天長陰線低開低走並跌入前陽實體，表明多頭力量衰竭，空頭接管。多見於強勢上漲後，預示趨勢反轉可能。',
    desc3: '底部反轉信號。先是一根長陰線，次日低開但強勢拉升，收盤價站上前陰實體中部以上，顯示多方積極進攻，空頭壓力減弱。常出現在連續下跌後的企穩階段，是短期反彈信號。',
    desc4: '頂部反轉形態。先出現一根長陽線，次日跳空高開但收盤大幅下挫，跌破前陽線實體中部，顯示多頭上攻受阻，空頭反擊有效。若伴隨放量，反轉信號更強，預示上漲趨勢可能終結。',
    desc5: '底部反轉信號。實體短、下影線長，上影極短或無，說明空頭曾大幅打壓但被多頭吸收並反攻。常出現在下跌末端，顯示下方買盤活躍。若次日有陽線確認，止跌企穩信號較強。',
    desc6: '頂部警示形態。實體較短、下影線很長，上影極短或無，多見於上漲末期。說明盤中出現較大拋壓，雖被多頭回收，但顯示多頭力量開始衰減。若第二天出現陰線確認，反轉概率提升。',
    desc7: '底部反轉形態。先長陰下跌，第二天跳空小實體，第三天長陽強勢收復前陰。顯示空頭衰竭，多頭主導行情。若伴隨放量和均線支撐，是較強的見底信號。',
    desc8: '頂部反轉形態。第一天長陽上漲，第二天跳空小實體，第三天長陰線跌回前陽實體內。顯示上漲動能減弱、空頭力量接管。若伴隨高位放量，是強烈的見頂信號，常預示趨勢轉空。',
    desc9: '連續三根長陽線，收盤價逐步抬高，買盤持續增強。多見於下跌末期或震盪整理後，預示多頭掌控局面。若成交量同步放大，是強烈的上漲延續信號。',
    desc10: '連續三根長陰線，收盤價逐步走低，實體接近最低點，顯示空頭強勢佔優。通常出現在高位，代表上漲趨勢結束，市場轉向下跌。成交量放大時信號更可靠。',
    desc11: '上漲趨勢中，先陽後陰再接陽。中間陰線未破支撐，多頭快速反攻並延續上行。反映市場回調有限，多方力量佔優。',
    desc12: '下跌趨勢中，先陰後陽再接陰。中間陽線未能突破關鍵阻力，空頭迅速反擊並延續下跌。顯示市場反彈無力，空方主導趨勢。',
    desc13: '小陰線後出現更長陽線完全吞沒前一根實體。顯示多方力量強勁，空頭退場。若伴隨底部放量，是常見的反轉信號，預示行情可能上行。',
    desc14: '小陽線後大陰線完全吞沒前陽，空頭力量強勢反撲。常見於頂部或反彈末端，顯示上漲動能衰退，是短線轉空信號。',
    desc15: '先一根長陽，隨後數根小陰回調震盪不破關鍵支撐，最後再接長陽線突破上行。多方主導行情，屬於上漲中繼形態，顯示趨勢穩固。',
    desc16: '先一根長陰，隨後數根小陽在其區間內震盪，最後再接長陰線下破。顯示空方暫緩後再次發力，延續下跌趨勢，屬於下跌中繼形態。',
    desc17: '連續多根K線的下影低點基本持平，顯示下方支撐強勁，拋壓逐漸被吸收。常出現在下跌末端，若隨後出現陽線突破，是築底反轉信號。',
    desc18: '連續多根K線上影高點接近同一水平，顯示上方壓力沉重。上漲乏力，易引發回調或反轉。若隨後的K線為陰線，信號更強烈。',
    },
    warrantStatement:{
    hkWarrantStatement:"港股權證字段說明",
    rotationInfo:"輪證介紹",
    warrant_title:"窩輪（Warrant）",
    warrant_desc:"即認購認沽權證，由發行人賦予持有人在到期日按行使價買入（認購）或賣出（認沽）相關資產的權利，投資權證實質上是對基礎資產價格方向的杠桿化投資，窩輪無強制收回機制。",
    cbbc_title:"牛熊證（CBBC）",
    cbbc_desc:"牛熊證為一種杠桿型結構性投資產品，用於追蹤基礎資產的價格表現，一旦基礎資產價格觸及贖回價格，發行人將強制贖回，產品終止交易，剩余價值取決於贖回時的結算價格，可能低至零。",

    namingRule:"命名規則",
    namingRule_info:"【資產簡稱】+【發行商簡稱】+【到期年份/月份】+【方向】+【行使價或序列號】",
    namingRule_detail1:"對於窩輪，看漲看跌分別用“購”、“沽”表示；對於牛熊證，看漲看跌分別用“牛”、“熊”表示；",
    namingRule_detail2:"到期年份一般以數字表達，例如2026年到期，則以數字“六”；",
    namingRule_detail3:"到期月份中，1月至10月以數字表達（一、二...十），11月、12月分布以“甲”、“乙”代表；",
    namingRule_detail4:"序列號為同一發行商就同一資產發行同一到期年月的衍生權證進行序列編號（A,B,C...或1,2,3...）；",

    publicFieldStatement:"公有字段說明",
    publicFieldStatement_title1:"街貨量/街貨比",
    publicFieldStatement_desc1:"市場上尚未被發行商回收、由投資者持有的權證數量及其占發行總量的比例。街貨量或街貨比越高，說明投資者持有的權證數量越多，此時權證價格越受市場供求影響。",
    publicFieldStatement_title2:"溢價",
    publicFieldStatement_desc2:"表示買入權證並行使權利取得正股，相較於直接買入正股所需承擔的額外成本。溢價越高，正股需有更大價格變動，權證才具備盈利空間。",
    publicFieldStatement_title3:"打和點",
    publicFieldStatement_desc3:"在到期日，權證投資者實現不盈不虧時，正股所需達到的價格水平。正股價格需超過（認購）或低於（認沽）打和點，權證才可能產生收益。",
    publicFieldStatement_title4:"換股價",
    publicFieldStatement_desc4:"按權證條款折算後，行使權證換取正股所對應的等效價格。該價格反映投資者通過權證參與正股的實際成本。",
    publicFieldStatement_title5:"換股比率",
    publicFieldStatement_desc5:"行使權證時，所需權證份數與可換取正股數量之間的比例關系，換股比率決定權證價格與正股價格之間的換算方式。",
    publicFieldStatement_title6:"行使價",
    publicFieldStatement_desc6:"權證合約中約定的正股買入價（認購）或賣出價（認沽），正股價格需相對行使價處於有利位置，權證才具備內在價值。",
    publicFieldStatement_title7:"杠桿比率",
    publicFieldStatement_desc7:"在其他條件不變的情況下，權證價格相對於正股價格變動的放大倍數。杠桿比率越高，價格波動幅度與投資風險越大。",
    publicFieldStatement_title8:"最後交易日",
    publicFieldStatement_desc8:"權證在交易所可進行買賣的最後一個交易日，超過該日期，權證將停止交易。",
    publicFieldStatement_title9:"到期日",
    publicFieldStatement_desc9:"權證合約正式到期並進行現金結算或價值確認的日期，到期時若未符合行權條件，權證可能失去全部價值。",
    
    warrantFieldStatement:"窩輪專屬字段說明",
    warrantFieldStatement_title1:"引伸波幅",
    warrantFieldStatement_desc1:"由權證或衍生產品市場價格反推得出的正股未來價格波動預期水平。引伸波幅越高，代表市場預期正股未來波動越大，在其他條件不變的情況下，引伸波幅上升通常有利於權證價格。",
    warrantFieldStatement_title2:"對沖值",
    warrantFieldStatement_desc2:"正股價格每變動一個單位時，權證理論價格的對應變動幅度。對沖值介乎 0 至 1（認購）或 0 至 -1（認沽），數值越接近 1（或 -1），權證價格走勢越接近正股。",

    bullAndBearFieldStatement:"牛熊證專屬字段說明",
    bullAndBearFieldStatement_title1:"收回價",
    bullAndBearFieldStatement_desc1:"牛熊證條款中設定的強制收回價格水平。當正股或相關指數觸及收回價，產品將即時終止，投資者可能只獲得極低甚至零的剩余價值。",
    bullAndBearFieldStatement_title2:"距收回價",
    bullAndBearFieldStatement_desc2:"現時正股價格與牛熊證收回價之間的差距，通常以價格或百分比表示。距離越小，觸發強制收回的風險越高；距離越大，短期內被收回的風險相對較低。",
  },
  shareOption: {
    title: '股票市場信息繁雜，期權具有高槓杆與低成本試錯的特性，“聰明錢”往往傾向通過期權提前佈局潛在消息，期權動態數據可以幫你從紛繁數據中，提煉出資金動向與市場情緒變化。',
    title1: '期權異動',
    desc11: '當某個期權合約突然出現大單成交、異常放量或隱含波動率急劇變化時，通常意味着：',
    desc12: '期權異動並不等同於“必然方向”，但往往是值得重點跟蹤的風險與機會信號源。',
    desc1li11: '市場對某一事件或預期產生了明顯分歧或共識',
    desc1li12: '大資金正在提前建倉或調倉',
    desc1li13: '可能有部分參與者提前對潛在消息作出反應',
    title2: '期權成交榜',
    desc21: '成交榜反映的是當日最活躍的期權合約：',
    desc1li21: '成交量高 → 流動性強、買賣價差小',
    desc1li22: '成交活躍 → 多空博弈集中，情緒更容易在這些合約上放大',
    desc1li23: '標的越靠前 → 市場關注度越高，往往對應當下的熱門主題或事件',
    title3: '期權持倉榜',
    desc31: '如果說成交量反映的是當下的“熱度”，那麼持倉量（未平倉合約數量）更像是市場的“態度”，通過持倉榜，你可以觀察：',
    desc1li31: '哪些股票或指數被持續、長期關注',
    desc1li32: 'Put/Call 哪一側持倉更重，反映中長期多空力量對比',
    desc1li33: '結合執行價分佈，可大致判斷市場對未來走勢的偏樂觀還是偏保守',
    title4: '財報期權',
    desc41: '每到財報季，期權市場會變得格外敏感，財報期權可以做爲業績發佈前的“押注地圖”：',
    desc1li41: '哪些股票即將發佈財報，提前鎖定潛在波動標的',
    desc1li42: 'Put/Call 的持倉量比、成交量，觀察市場對財報結果的押注方向',
    tips: '期權動態內容僅用於市場信息展示與一般性分析說明，不構成任何形式的投資建議、買賣邀約或承諾。',
  },
 portfolio: {
    portfolioIntroduction:"盈寶投資組合",
    portfolioIntroductionMore:"盈寶投資組合",
    investPortfolio:"投資組合",
    fundInventment:"基金投資",
    purchaseActualAssets:"買入實際股票資產",
    purchaseFundShares:"買入基金份額",
    managementFeeOnly:"只收管理費",
    managementFee:"管理費",
    serviceFee:"服務費",
    hostingFeeEtc:"托管費等",
    discloseHoldAndTrade:"持倉、交易完全披露",
    discloseHoldTopTen:"每季度披露前十持倉",
    regularlyReleaseStrategy:"定期發布組合策略洞察",
    releaseLessInterpretation:"極少發布基金策略解讀",
    openEntrustedAccount:"開立盈寶投資組合全權委托賬戶",
    choicePortfolioAndInvested:"選擇組合投入並劃轉投入資金",
    autoPurchaseStockForYourAssets:"盈寶根據組合資產配置，自動為您買入組合成分股",
    viewEarnDetailAfterPurchase:"組合成分股買入成功後，可查看組合每日收益明細",
    autoAdjustHoldForMonitor:"實時監測組合持倉，並根據組合策略為您自動調倉",
    portfolioConstitute:"投資組合是由",
    stockAndBondEtfCashEtc:"股票、債券、ETF、現金等",
    moreCategoryFinanceSchame:"多類金融資產構成的整體配置方案",
    professionalTermManage:"盈寶投資組合由專業投研團隊統一管理，根據客戶的收益目標與風險偏好進行科學配置，覆蓋資本增長、穩健收益及區域投資等需求。通過多資產、多維度分散配置，在有效控制風險的同時，力求實現長期穩健的投資回報",
    professionalManage:"專業管理",
    serviceProvideForFinanceTerm:"資深金融團隊提供專業、可靠的理財服務",
    disciplinedInvesting:"紀律投資",
    avoidForMarketAttitude:"避免投資受市場情緒左右，保持組合最優狀態",
    brokenStockTrade:"碎股交易",
    premiumAssetsForFiveHundred:"低至500美元即可投一籃子優質資產，分散投資",
    extremelyLowCost:"極低成本",
    noCommissionAndPlatformFee:"除了極低第三方交易代收費，無傭金和平臺費",
    coreConfiguration:"核心配置債券類ETF，靈活配置少量股票類ETF，不錯過熱點機會",
    assetDiversification:"資產分散，降低單一市場與單一資產風險，關註回撤管理，提升持有過程的舒適度",
    avoidEmotionality:"結合量化數據模型和AI技術進行投資決策，避免個人情緒化投資",
    noLockPeriod:"無鎖定期，隨時認購、贖回",
    lowThresholdParticipation:"低門檻參與，充分釋放閑置資金價值",
    zeroSubscriptionFee:"零認購費，月度管理費低至 0.1%",
    incomeSinceBuild:"成立以來10個自然季度中，8個季度實現正收益",
    incomeRate:"收益率",
    portfolioIncome:"組合收益",
    wenyingbao:"穩盈寶",
    robustConfiguration:"穩健配置，堅如磐石",
    lowerMaximumDrawdown:"經歷中美貿易戰、矽谷銀行危機等事件，組合仍保持低至 -3.36%的最大回撤",
    dataTipForBottom:"*數據說明見底部",
    steadyPaceLeads:"行穩致遠，向上而行",
    reasonableParticipation:"合理參與市場上行機會，實現穩中求進的長期目標",
    peaceMindAndAssured:"安心、放心、省心",
    professionalProtection:"放下投資焦慮，我們的專業團隊時刻在背後守護",
    robustnessPrinciple:"穩健配置的策略核心原則",
    historyIncomePerformance:"歷史收益表現",
    EfficientCapitalOperation:"兼顧交易與理財，讓資金高效運轉",
    resultDataTip:"*數據說明：本頁面所展示的數據為截至 2026-01-05 的投資組合實際業績統計結果。",
    riskTip:"*風險提示：投資組合過往業績不預示未來表現。請在選擇投資組合服務前，確認該組合符合自身的風險承受能力、投資期限和投資目標。",
    strictSelectionEtf:"嚴選ETF",
    stockRelatedEtf:"以股票類ETF",
    configureHost:"為主進行配置",
    dynamicAdjustment:"動態調整",
    withMarketChanges:"隨市場變化",
    optimizeAssets:"優化股債資產比例",
    disciplineEnforcement:"紀律執行",
    followStrategicRules:"遵循策略規則",
    avoidEmotionalTrading:"避免情緒化操作",
    noLockPeriodForReturn:"無鎖定期，隨時認購、贖回",
    lowThresholdReleaseFunds:"低門檻參與，充分釋放閑置資金價值",
    noSubscriptionAndLowerManageFee:"零認購費，月度管理費低至 0.1%",
    yingduoduo:"盈多多",
    onlySetEtf:"僅配置ETF，不直接配置個股",
    moreQuaterPositive:"多季度實現正收益",
    strictlyControlDrawdown:"嚴控回撤，享受更平穩持續的收益體驗",
    yingduoduoAdvantage:"盈多多投資組合優勢",
    bothTradingAndFinancial:"兼顧交易與理財，讓資金高效運轉",
    yingduoduoRiskTip:"*風險提示：投資組合過往業績不預示未來表現。請在選擇投資組合服務前，確認該組合符合自身的風險承受能力、投資期限和投資目標。",
    researchDeep:"深度研究",
    priorityResearchPpportunity:"重點研究股票資產配置機會",
    riskManage:"風險管理",
    bufferingPortfolioVolatility:"以債券配置緩沖組合波動",
    profitBalance:"收益平衡",
    bothBenefitsAndRisks:"兼顧收益與風險，提升投資體驗",
    cumulativeIncome:"累計收益",
    annualizedVolatility:"年化波動率",
    maximumDrawdown:"最大回撤",
    youxuanbeimeiDataTip:"統計數據為截止時間至2026-01-05，優選北美組合成立以來的實際收益數據，業績基準為SPDR彭博1-3月美國國庫券ETF*10%+SPDR標普500指數ETF*90%",
    preferredBeimeiPortfolio:"優選北美組合",
    performanceBenchmark:"業績基準",
    annualizedVolatilityTip:"年化波動率是衡量投資組合收益波動程度的指標，代表組合收益變化的幅度。波動越大，說明收益起伏越劇烈。",
    youxuanbeimei:"優選北美",
    highQualityStocks:"北美優質股票 鎖定增長潛力",
    targetAnnualizedIncome:"目標年化收益＞10% ，捕捉向上周期行業",
    mediumLongAllocation:"中長期視角資產配置，優選行業核心龍頭",
    moreIndustryInvestment:"多行業分散投資，爭取獲得更均衡的回報",
    scientificAllocation:"科學配置，確保增長之路上的安全",
    quantitativeModel:"建立量化數據模型，科學研判資產投資價值",
    hedgingStrategy:"適時建立對沖策略，降低市場波動影響",
    bigDataAndAi:"大數據和AI輔助決策，實時監控市場波動",
    surpassMarketIncome:"超越市場收益，波動更小、回撤更低",
    followThemarket:"跟隨市場脈動，捕捉市場機會",
    highMarketCompanies:"高市值企業，低投資門檻",
    suitableForInvestors:"適合投資者",
    beimeiyouxuanRisk:"*風險提示：投資組合過往業績不預示未來表現。請在選擇投資組合服務前，確認該組合符合自身的風險承受能力、投資期限和投資目標。",
    lowThresholdTo:"投資組合投資門檻低至",
    subscribeAnyTime:"隨時申購",
    flexibleTransfer:"靈活轉出",
    matureMarket:"偏好成熟市場",
    diversifiedInvestment:"偏好多元化投資",
    longTermInvestment:"立足長期投資",
    suitableRobustInvestors:"適合追求穩健長期收益投資者，在不確定的市場中獲得穩定的財富增長",
    assetGrowth:"以權益資產為增長引擎，輔以債券配置平抑波動，力爭更優風險回報比",
    whyPortfolio:"什麽是投資組合？",
    howExcutePortfolio:"我們如何幫您執行組合投資？",
    differentWithFunds:"投資組合與基金有什麽不同？",
    whyChoicePortfolio:"為什麽選擇投資組合？",
    fullDelegationService:"全委托投資組合服務",
    whyPortfolioIsBest:"- 為什麽投資組合是最好的長期投資方式 -",
    moreImportantInvestment:" 有研究表明，長期投資中約70%–90% 的收益來自資產配置，而非擇時或個股選擇；",
    reduceAssetRisk:" 組合資產分散配置，在保持長期收益潛力的同時，有效降低風險；",
    reasonableInvestmentPlan:" 投資組合本質不是選股，而是選擇一套與風險需求匹配的投資方案；",
    dsignForLongTime:"- 盈寶投資組合：為長期投資而設計 -",
    assetLowThresholdTo:"投資一攬子優質股票資產門檻低至",
    transactionTransparency:"組合配置、調倉交易清晰透明",
    longTermValidation:"組合策略經過較長周期的實際運行與驗證",
    portfolio:"組合",
    riskLevel:"風險等級",
    riskLevelLowMedium:"中低風險",
    riskLevelMedium:"中風險",
    buildDays:"成立天數",
    annualizedIncome:"年化收益",
    investmentTarget:"投資目標",
    steadyAppreciation:"穩健增值",
    growthFirst:"成長優先",
    regionalCoreAssets:"區域核心資產",
    targetAudience:"適合人群",
    lowVolatilityPreference:"低波動偏好",
    balancedReturn:"均衡收益型",
    aggressiveAllocation:"進取配置型",
    portfolioDataTip:"*數據統計時間截至2026-06-30，投資組合過往業績不預示未來表現。請在選擇投資組合服務前，確認該組合符合自身的風險承受能力、投資期限和投資目標。",
    highQualityPortfolio:"- 優質組合，成就長期投資的力量 -",
    investmentAmount:"投資金額",
    scenarioSimulation:"基於10,000美元初始投資的組合收益情景模擬",
    investmentTerm:"投資時長",
    year:"年",
    scenarioSimulationTip:"*組合收益測算基於歷史年化表現進行推算，僅作情景示例，不構成收益承諾。過往業績不代表未來表現。",
    portfolioInvestmentSystem:"- 為長期而構建的組合投資體系 -",
    carefullyHighQualityEtf:"嚴選優質ETF與核心資產，構建專業化底層配置；",
    aiQuantitativeModel:"基於宏觀周期框架與AI量化模型，識別市場輪動階段；",
    modelDriven:"以戰略資產配置為核心，模型驅動長期結構方向；",
    strengthenBacktesting:"強化回撤管理與波動控制，提升持有體驗與穩定性。",
    customerIncome:"- 陪伴客戶走過的投資旅程 -",
    customer:"客戶",
    portfolioName:"組合名稱",
    startTimeForInvest:"開始投資時間",
    holdIn:"持有",
    sky:"天",
    totalIncomeRate:"累計收益率",
    customerName:"客戶姓名",
    holdInDays:"持有自然日",
    cusIncomeDataTip:"*數據來自盈寶部分真實客戶歷史投資記錄統計，追加投入、部分轉出可能導致累計收益率統計產生差異，數據僅作為歷史展示，不構成任何投資建議或收益承諾。",
    nomalQuestion:"- 常見問題 -",
    whoManagePortfolio:"投資組合由誰管理",
    whoManagePortfolioDesc:"盈寶提供全權委托投資管理服務。您的投資組合由盈寶專業投資團隊全權負責，包括資產配置、動態調倉、風險控制等日常管理。",
    investPortfolioLockTerm:"投資組合是否設最低投資金額或鎖定年期",
    investPortfolioLockTermDesc:"最低起投金額為500美元，無任何鎖定期。您可隨時提交申購或贖回申請。",
    howLongTimeForUpdate:"投資組合收益數據多久更新",
    howLongTimeForUpdateDesc:"投資組合凈值及持倉數據每個交易日更新一次。通常於交易日下午5:00，APP會以最新收市價格及當日持倉情況完成數據刷新。",
    howLongTimeAdjust:"投資組合多久調倉一次",
    howLongTimeAdjustDesc:"調倉頻率並非固定，而是由策略驅動。我們會根據市場環境、資產估值與風險特征，定期進行組合再平衡，並在必要時主動調整以優化風險收益特征或控制下行風險。所有調倉操作均不收取額外費用。",
    whiceFeeForPortfolio:"買賣投資組合需要支付哪些費用",
    whiceFeeForPortfolioDesc1a:"盈寶堅持極致低成本原則，對於投資組合，",
    whiceFeeForPortfolioDesc1b:"不收取",
    whiceFeeForPortfolioDesc1c:"以下任何費用：",
    whiceFeeForPortfolioDesc11:"平臺管理費",
    whiceFeeForPortfolioDesc12:"經紀傭金",
    whiceFeeForPortfolioDesc13:"申購費",
    whiceFeeForPortfolioDesc14:"贖回費",
    whiceFeeForPortfolioDesc2:"實際收取的費用僅包括兩類：",
    whiceFeeForPortfolioDesc21:"投資組合管理費：由盈寶收取，費率因不同組合而異，請參閱具體組合詳情頁。",
    whiceFeeForPortfolioDesc22:"第三方機構費用：包括交易所收取的交易經手費、監管費、分紅預扣稅、ADR托管費等。這些為市場通行費用，盈寶僅代收代付，不額外加收任何平臺費或傭金。",
    howToViewFeeDetail:"如何查看已支付的管理費明細",
    howToViewFeeDetailDesc1:"管理費通常於每月第一個工作日計提上月費用。您可通過以下方式查看：",
    howToViewFeeDetailDesc11:"盈寶發送的日、月電子結單郵件",
    howToViewFeeDetailDesc12:"登錄盈寶App → “我的” → “我的結單” → “組合”欄目，通過結單查看詳細費用明細",
    isIncludeDivideForProfit:"投資組合收益是否包含分紅派息",
    isIncludeDivideForProfitDesc:"投資組合收益包含分紅派息和資本增值（即投資組合本身資產升值）。",
    howToViewDivide:"如何查看投資組合的分紅派息",
    howToViewDivideDesc1:"可以在持有組合詳情頁查看，或者通過結單查看",
    capitalUseInmedia:"賣出投資組合，資金可否立即使用",
    capitalUseInmediaDesc1:"贖回資金需等待交易執行完成及資金交收完畢後方可再次使用或轉出。具體交收時間取決於組合主要持倉市場：",
    capitalUseInmediaDesc11:"全部為香港市場標的 → T+2 日交收",
    capitalUseInmediaDesc12:"全部為美國市場標的 → T+1 日交收",
    capitalUseInmediaDesc13:"同時持有香港及美國市場標的 → 統一按T+2 日交收",
    capitalUseInmediaDesc1Tip:"（T指贖回指令成交日，實際到賬時間以清算機構確認為準）",
    canFinanceBuyPortfolio:"是否可以融資買入投資組合",
    canFinanceBuyPortfolioDesc:"目前暫不支持融資買入投資組合。我們會持續關註市場需求，適時推出相關功能，敬請留意後續公告。",
    jingxuanyinglun:"精選英倫",
    openPortfolioimedia:"一鍵開通投資組合",
    startToInvest:"開始組合投資",
    assetValueUsd:"資產凈值(USD)",
    dollar:"美元",
    nomalQuestion:"常見問題",
    aiInsight:"組合洞察"
   },
  investProtocol:{
    investmentProtocol:"推薦投資協議",
    agreenProtocol:"同意協議",
    sumitSuccess:"提交成功",
    confirmAgreenProtocol:"確認是否同意協議？",
    investmentAdvisoryProtocol:"投資顧問協議"
   },
   magicNineTurns:{
    title1:"指標簡介",
    introduction1:"神奇九轉指標（TD Sequential）由著名技術分析大師 Tom DeMark 提出，是一類基於價格行為的趨勢節奏分析指標。其核心思想在於：價格趨勢並非無限延續，當股價在同一方向持續運行時，市場內在動能將逐步消耗，趨勢進入衰竭階段的概率隨之上升。",
    introduction2:"該指標主要用於識別趨勢後期可能出現的節奏變化或拐點風險，為投資者在上漲或下跌行情中提供風險提示和決策參考，而非對短期走勢作出確定性預測。",
    title2:"指標基本結構",
    structure1:"神奇九轉通過對價格相對位置進行連續計數，構建趨勢序列結構：",
    structure2:"當前K線的收盤價高於（或低於）前第4根K線的收盤價；",
    structure3:"且該條件連續滿足 9 根 K 線；",
    structure4:"則形成一個完整的上漲九轉或下跌九轉序列。",
    structure5:"在實際展示中，當計數進行至第 6 根 K 線時，序列信號開始出現；",
    structure6:"若在後續第 7、8、9 根 K 線中條件不再滿足，則該九轉序列自動失效並消失，表明趨勢節奏尚未完成。",
    title3:"指標應用",
    application1:"九轉信號並不代表趨勢必然立即反轉，而是提示當前行情可能進入高波動或高風險階段，市場更容易出現震蕩整理或趨勢結構變化。",
    application2:"從本質上看，神奇九轉用於刻畫趨勢過度延續與情緒偏離的狀態，適合輔助判斷市場是否處於過度樂觀或悲觀區間。在實際應用中，建議結合基本面、市場環境及關鍵價位進行綜合分析，以提升判斷的穩健性。"
   },
   article: {
    articleErr: '文章加載失敗，請稍後重試',
    author: '作者',
    comment: '評論',
    noComment: '暫無評論',
    writeComment: '寫評論',
    openAppToReadBetter: '打開盈寶證券App，更佳閱讀體驗',
    remainingText1: '還有剩餘',
    remainingText2: '%的精彩內容！ ',
    disclaimer:
      '免責聲明：上述內容僅為發布者個人觀點，不構成盈寶或本社區的任何投資建議，盈寶或本社區不承擔因上述發布者言論引起的任何損失和損害。 ',
    pay: '支付',
    wbCoin: '盈寶幣',
    followAuthor: '關注作者',
    continueRead: '繼續閱讀',
    reply: '回复',
    minuteAgo: '分鐘前',
    hoursAgo: '小時前',
    daysAgo: '天前',
    justNow: '剛剛',
    anonymous: '匿名',
    longPic: '長圖',
    modifyOn: '修改於',
    toDay:"今日",
    yesterday :"昨天",
    disclaimer2:"免責聲明：上述內容僅為發布者個人觀點，僅供參考，不構成任何投資建議。",
  },
  shortSelling:{
    riskProtocol:"風險協議",
    financeSecurityProtocol: "融券協議"
  },
  shanghaiHkShenzhen:{
    connectTitle:"滬港通&深港通",
    desc1:"滬港通、深港通，是連接中國內地與香港資本市場的“投資橋梁”，它既讓內地投資者可以直接投資港股，也讓香港、境外資金參與A股市場，是一套雙向開放的互聯互通機制。",
    desc2:"在滬港通、深港通體系中，內地投資者投資港股的通道被稱為港股通（或南向通），只有被納入“港股通標的名單”的港股，才可以通過該通道進行交易。",
    desc3:"並非所有港股都支持港股通交易，一般而言，納入港股通（即“入通”）需滿足以下核心條件：",
    desc31:"市值與規模：通常屬於恒生綜合指數成分股，以大盤股和中盤股為主；",
    desc32:"流動性：日均成交活躍，具備良好的買賣深度；",
    desc33:"交易狀態：正常交易（非長期停牌），無重大風險或異常情況；",
    desc4:"港股通標的實行動態管理機制，一般情況下，每年在3月和9月會調整港股通名單，包括新納入和剔除，部分大型IPO公司上市後較快被納入恒生指數，從而快速入通。",
    desc5:"當一只港股被納入港股通，意味著其進入內地資金（南向資金，也稱“北水”）的投資範圍，通常會帶來流動性提升，並可能對股價和估值產生階段性影響。"
  },
  usOptionTeach:{
    usOptionTeach:"期權教學"
  },
  ipoAnalysis:{
    aiAnalysisDetail:"AI評級明細",
    analysisTime:"分析時間",
    tip:"溫馨提示：本內容由AI基于公開市場信息、IPO相關數據分析生成，AI評級結果可能跟隨市場申購熱度、AH折溢價率等動態調整，不代表任何投資建議。",
    applicationRating:"申購評級",
    comprehensiveRating:"綜合評分",
    demension:"維度",
    score:"評分",
    coreJudgement:"核心判斷",
    conclusion:"結論",
    goToSub:"前往認購"
  },
  aiPortfoliInsight:{
    insightTip:"溫馨提示：當前內容僅供參考，不構成投資建議。"
  }
}
